import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import HotelManagementService from '@/service/HotelManagementService';

export const useNotesManagementStore = defineStore('notesManagementStore', {
  state: () => ({
    notes: []
  }),
  getters: {
    selectListNotes: (state) => state.notes
  },
  actions: {
    async handleGetListNotes(code, type) {
      const hotelManagementService = new HotelManagementService();
      try {
        const res = await hotelManagementService.getListNotes(code, type);
        this.updateListNotes(res?.data);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async handleAddNotes(code, payload, type) {
      const hotelManagementService = new HotelManagementService();
      const response = await hotelManagementService.addNotes(code, payload, type);
      return response;
    },
    async handleDeleteNotes(code, noteId, type) {
      const hotelManagementService = new HotelManagementService();
      const response = await hotelManagementService.deleteNotes(code, noteId, type);
      return response;
    },
    updateListNotes(payload) {
      this.notes = payload;
    }
  }
});
